import React, { useState } from 'react';
import { Form, Input, Button, message, ConfigProvider } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LmHeader from '../components/LmHeader.jsx';
import LmFooter from '../components/LmFooter.jsx';
import staffAntdTheme from '../theme/staffAntdTheme.js';

const STAFF_LOGO_COLOR = '#1A1A1A';

const Login = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post('https://limitverify.ru:5000/api/auth/login', {
        email: values.email,
        password: values.password
      });

      message.success('Вход выполнен успешно!');

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      const savedToken = localStorage.getItem('token');
      const savedUser = localStorage.getItem('user');

      if (savedToken && savedUser) {
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 300);
      } else {
        message.error('Ошибка сохранения данных авторизации');
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.data?.error) {
        message.error(error.response.data.error);
      } else {
        message.error('Ошибка при входе. Проверьте email и пароль.');
      }
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    message.error('Пожалуйста, заполните все поля.');
  };

  return (
    <ConfigProvider theme={staffAntdTheme}>
      <div className="lm-page lm-page--staff">
        <LmHeader
          logoColor={STAFF_LOGO_COLOR}
          actions={[
            { label: 'Главный экран', onClick: () => navigate('/') },
            { label: 'Вход для клиентов', onClick: () => navigate('/enter') },
          ]}
        />

        <main className="lm-content lm-content--center">
          <div className="lm-auth lm-auth--staff">
            <span className="lm-staff-badge">Административная панель</span>

            <div className="lm-auth__head">
              <h1 className="lm-auth__title">Вход для сотрудников</h1>
              <span className="lm-auth__sub">Доступ к системе управления Лимитек</span>
            </div>

            <Form
              form={form}
              name="login"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              requiredMark={false}
              className="lm-auth__form"
            >
              <Form.Item
                name="email"
                label="Корпоративный email"
                style={{ marginBottom: 0 }}
                rules={[
                  { required: true, message: 'Пожалуйста, введите email!' },
                  { type: 'email', message: 'Пожалуйста, введите корректный email!' }
                ]}
              >
                <Input placeholder="email@company.ru" />
              </Form.Item>

              <Form.Item
                name="password"
                label="Пароль"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: 'Пожалуйста, введите пароль!' }]}
              >
                <Input.Password placeholder="••••••••" />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  style={{ textTransform: 'uppercase' }}
                >
                  Войти в систему
                </Button>
              </Form.Item>

              <button
                type="button"
                className="lm-link"
                onClick={() => navigate('/forgot-password?type=user')}
              >
                Забыли пароль?
              </button>
            </Form>

            <div className="lm-auth__row">
              <span className="lm-link">Нет аккаунта?</span>
              <button
                type="button"
                className="lm-link lm-link--light"
                onClick={() => navigate('/register')}
              >
                Зарегистрироваться
              </button>
            </div>
          </div>
        </main>

        <LmFooter />
      </div>
    </ConfigProvider>
  );
};

export default Login;
